export * from '../dist/esm/linear-gradient'
